export { default as QuickBookingRestCard } from './QuickBookingRestCard'
